import { render } from "./AddCase.vue?vue&type=template&id=d77cb40c&scoped=true"
import script from "./AddCase.vue?vue&type=script&lang=js"
export * from "./AddCase.vue?vue&type=script&lang=js"

import "./AddCase.vue?vue&type=style&index=0&id=d77cb40c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d77cb40c"]])

export default __exports__